import React from 'react';
import { Pane, PaneProps } from 'evergreen-ui';
import {
  useSelectedDangerMode, useSelectedDataReceived, useSelectedEnabledMode, useSelectedStormMode,
} from '../hooks';
import EnableModeStatusSelect from '../EnableModeStatusSelect';
// import SoftReleaseStatusSelect from '../SoftReleaseStatusSelect';
import DangerModeStatusSelect from '../DangerModeStatusSelect';
import DataReceivedStatusSelect from '../DataReceivedStatusSelect';
import StormModeStatusSelect from '../StormModeStatusSelect';

export function DatasourcesFilterByStatuses(props: PaneProps) {
  const { enableMode, onSelectEnableMode } = useSelectedEnabledMode();
  const { dangerMode, onSelectDangerMode } = useSelectedDangerMode();
  // const { softRelease, onSelectSoftRelease } = useSelectedSoftRelease();
  const { dataReceived, onSelectDataReceived } = useSelectedDataReceived();
  const { stormMode, onSelectStormMode } = useSelectedStormMode();

  return (
    <Pane display="flex" gap=".2rem" {...props}>
      <EnableModeStatusSelect selected={enableMode} onSelect={onSelectEnableMode} />
      <DangerModeStatusSelect selected={dangerMode} onSelect={onSelectDangerMode} />
      <DataReceivedStatusSelect selected={dataReceived} onSelect={onSelectDataReceived} />
      <StormModeStatusSelect selected={stormMode} onSelect={onSelectStormMode} />
      {/* <SoftReleaseStatusSelect selected={softRelease} onSelect={onSelectSoftRelease} /> */}
    </Pane>
  );
}
